<template>
  <div :class="['brands', { 'brands--filter-ready': filterReady }]" id="brands">
    <template v-if="pageMode === 'managers'">
      <ul>
        <li
          :style="`width: ${width(brandsManagersCalculated.length)}%; flex-basis: ${width(brandsManagersCalculated.length)}%;`"
          v-for="(brand, index) in brandsManagersCalculated"
          :key="index"
        >
          <Brand
            :brand="brand.name"
            :logo="brand.logo"
            :filter-logo="brand.filterLogo"
            :slug="brand.slug"
            :copy="brand.copy"
            :link="brand.link"
            :link-text="brand.linkText"
            :background-image="brand.backgroundImage"
          />
        </li>
      </ul>
    </template>
    <template v-if="pageMode === 'suppliers'">
      <ul>
        <li
          :style="`width: ${width(brandsSuppliersCalculated.length)}%; flex-basis: ${width(brandsSuppliersCalculated.length)}%;`"
          v-for="(brand, index) in brandsSuppliersCalculated"
          :key="index"
        >
          <Brand :brand="brand.name" :logo="brand.logo" :slug="brand.slug" :copy="brand.copy" :link="brand.link" :link-text="brand.linkText" />
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { pageMode } from './../../mixins/pageMode.js'
import Brand from './Brand.vue'

export default {
  name: 'BrandContainer',
  components: {
    Brand,
  },
  data() {
    return {
      sets: {
        'never-settler': ['1850', 'cafe-bustelo'],
        'economist': ['folgers'],
        'busy-bee': ['folgers', '1850', 'cafe-bustelo']
      },
      brands: [
        {
          name: 'Folgers',
          slug: 'folgers',
          logo: 'Folgers_Assets_SimplifiedLogo_RGB_White.png',
          filterLogo: 'Folgers_Assets_SimplifiedLogo_RGB_White.png',
          copy: `The rich flavor and aroma of <strong>Folgers</strong> coffee is more than just coffee&mdash;it’s a tradition. Bring the familiar taste of home to your hard-working employees.`,
          link: 'https://www.smuckerawayfromhome.com/brands/folgers',
          backgroundImage: 'folgers-long-bg.jpg'
        },
        {
          name: '1850',
          slug: '1850',
          logo: '1850-combined.png',
          filterLogo: '1850-2.0_PrimaryLogo-Purple.png',
          copy: `Crafted using timeless traditions, <strong>1850</strong> coffee delivers a bold, yet smooth lineup of 100% Premium Arabica coffees.`,
          link: 'https://www.smuckerawayfromhome.com/brands/1850',
          backgroundImage: 'brand-overview-bg-1850@2x.jpg'
        },
        {
          name: 'Cafe Bustelo',
          slug: 'cafe-bustelo',
          logo: 'CafeBusteloLogo_Stacked_PMS@2x.png',
          filterLogo: 'CafeBusteloLogo_Stacked_PMS@2x.png',
          copy: `Born from a true passion for Latin coffee, <strong>Café Bustelo</strong><sup>®</sup> delivers an authentic coffee experience that satisfies employees who enjoy darker roasts.`,
          link: 'https://www.smuckerawayfromhome.com/brands/Cafe-Bustelo',
          backgroundImage: 'brand-overview-bg-cafe-bustelo@2x.jpg'
        },
        // {
        //   name: 'Select Brew',
        //   slug: 'select-brew',
        //   logo: 'SelectBrewLogo@2x@2x.png',
        //   filterLogo: 'SelectBrewLogo@2x@2x.png',
        //   copy: `The <strong>Select Brew</strong><sup>®</sup> Coffee System delivers fresh, consistent cups of coffee at the touch of a button. See how you can simplify coffee service featuring any of our brands!`,
        //   link: 'https://www.smuckerawayfromhome.com/brands/select-brew',
        // backgroundImage: 'brand-overview-bg-select-brew@2x.jpg'
        // }
      ],
    }
  },
  computed: {
    persona() {
      return this.$store.state.results.personaCalculated
    },
    emailSubmitted() {
      return this.$store.state.results.complete
    },
    brandsManagersCalculated() {
      if (this.persona && this.emailSubmitted) {
        return this.brands.filter((r) => {
          // console.log('r', r.slug)
          // console.log('asdf', this.sets[this.persona].includes(r.slug))
          return this.sets[this.persona].includes(r.slug)
        })
      } else {
        return this.brands
      }
    },
    brandsSuppliersCalculated() {
      return this.brands
    },
    filterReady () {
      return this.pageMode === 'managers' && this.emailSubmitted
    }
  },
  methods: {
    width(count) {
      return 100/count
    },
    // brandSelected(brand) {
    //   this.$emit('brandSelected', brand)
    // }
  },
  mixins: [pageMode]
}
</script>

<style lang="scss">

.brands {
  & > ul {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
  }
  @include breakpoint(xmedium down) {
    & > ul {
      & > li {
        width: 100% !important;
        flex-basis: 100% !important;
      }
    }
  }
  @include breakpoint(large) {
    & > ul {
      flex-flow: row nowrap;
    }
  }
}

/* .brands--filter-ready {
  padding-top: 1em;
  padding-bottom: 1em;
  & > ul {
    & > li {
      @include breakpoint(medium down) {
        border-bottom: 1px solid $grayer;
        &:last-child {
          border-bottom: none;
        }
      }
      @include breakpoint(large) {
        border-left: 1px solid $grayer;
        &:first-child {
          border-left: none;
        }
      }
    }
  }
} */

</style>